import React from 'react';
import MaterialSpinner from 'react-spinner-material';

export const Spinner = ({ width = 20 }) => (
  <div style={{ width, margin: 'auto' }}>
    <MaterialSpinner size={width} spinnerColor={"#FFF"} spinnerWidth={2} visible={true} />
  </div>
)